import axios from 'axios';
import config from './config';

// export const APIHost = 'http://10.50.51.175:8000';   // localhost office
// // export const APIHost = 'http://192.168.1.7:8000';   // localhost home
// // export const APIHost = 'http://192.168.43.63:8000';   // localhost mobile hotspot
// // export const APIHost = 'https://mvis-dp.as.r.appspot.com';   // GAE: MVIS-DP (dev)
const APIHost = config.APIHost;

export const urlAPI = APIHost + '/api';

export const versionAPI = '/v1/self';
// export const versionAPIMobile = '/mv1';


export function GetCaseStatus(data){
    return axios.post(urlAPI + versionAPI + '/getStt',data)
        .then(res => {
            return res
        })
    .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          // console.log(error.response.data,error.response.status,error.response.headers);
          var result = [];
          result["data"] = error.response.data;
          result["status"] = error.response.status;
          return result
        } else if (error.request) {
          // The request was made but no response was received
          // console.log(error.request);
          return "The request was made but no response was received"
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
          return "Something happened in setting up the request that triggered an Error"
        }
    });
}

export function startProgress(data){
    return axios.post(urlAPI + versionAPI + '/startProgress',data)
        .then(res => {
            return res
        })
    .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          // console.log(error.response.data,error.response.status,error.response.headers);
          var result = [];
          result["data"] = error.response.data;
          result["status"] = error.response.status;
          return result
        } else if (error.request) {
          // The request was made but no response was received
          // console.log(error.request);
          return "The request was made but no response was received"
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
          return "Something happened in setting up the request that triggered an Error"
        }
    });
}

export function GetInspectionCase(qString){
    // const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
    // return axios.get(urlAPI + versionAPI + '/claim'+qString,{
    // return axios.get(urlAPI + versionAPI + '/inspection'+qString,{
    //     headers: {
    //         Authorization: headers
    //     }
    // })
    // return axios.get(urlAPI + versionAPI + '/getCase'+qString)
    return axios.get(urlAPI + versionAPI + '/formdetail'+qString)
        .then(res => {
            return res
        })
    .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          // console.log(error.response.data);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          var result = [];
          result["data"] = error.response.data;
          result["status"] = error.response.status;
          return result
        } else if (error.request) {
          // The request was made but no response was received
          // console.log(error.request);
          return "The request was made but no response was received"
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
          return "Something happened in setting up the request that triggered an Error"
        }
    });
}

export function SaveInspection(data){
    // const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
    // return axios.get(urlAPI + versionAPI + '/claim'+qString,{
    // return axios.get(urlAPI + versionAPI + '/inspection'+qString,{
    //     headers: {
    //         Authorization: headers
    //     }
    // })
    return axios.post(urlAPI + versionAPI + '/saveCase',data)
        .then(res => {
            return res
        })
    .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          // console.log(error.response.data);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          var result = [];
          result["data"] = error.response.data;
          result["status"] = error.response.status;
          return result
        } else if (error.request) {
          // The request was made but no response was received
          // console.log(error.request);
          return "The request was made but no response was received"
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
          return "Something happened in setting up the request that triggered an Error"
        }
    });
}

export function SaveImage(data){
    // const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
    // return axios.get(urlAPI + versionAPI + '/claim'+qString,{
    // return axios.get(urlAPI + versionAPI + '/inspection'+qString,{
    //     headers: {
    //         Authorization: headers
    //     }
    // })
    return axios.post(urlAPI + versionAPI + '/saveImage',data)
        .then(res => {
            return res
        })
    .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          // console.log(error.response.data);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          var result = [];
          result["data"] = error.response.data;
          result["status"] = error.response.status;
          return result
        } else if (error.request) {
          // The request was made but no response was received
          // console.log(error.request);
          return "The request was made but no response was received"
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
          return "Something happened in setting up the request that triggered an Error"
        }
    });
}

// ////////// ใช้เฉพาะส่วนของถ่ายรูปเพิ่มเติม ////////// ----> ไม่ใช้แล้ว
// export function SaveImageAddOn(data){
//     // const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     // return axios.get(urlAPI + versionAPI + '/claim'+qString,{
//     // return axios.get(urlAPI + versionAPI + '/inspection'+qString,{
//     //     headers: {
//     //         Authorization: headers
//     //     }
//     // })
//     return axios.post(urlAPI + versionAPI + '/saveImageAddOn',data)
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

export function GetCaseStep(qString, tab){
    // const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
    // return axios.get(urlAPI + versionAPI + '/claim'+qString,{
    // return axios.get(urlAPI + versionAPI + '/inspection'+qString,{
    //     headers: {
    //         Authorization: headers
    //     }
    // })
    // return axios.get(urlAPI + versionAPI + '/getCase'+qString)
    return axios.get(urlAPI + versionAPI + '/' + tab + '/getCaseStep'+qString)
        .then(res => {
            return res
        })
    .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          // console.log(error.response.data);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          var result = [];
          result["data"] = error.response.data;
          result["status"] = error.response.status;
          return result
        } else if (error.request) {
          // The request was made but no response was received
          // console.log(error.request);
          return "The request was made but no response was received"
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
          return "Something happened in setting up the request that triggered an Error"
        }
    });
}

export function SaveCaseStep(data, tab){
    // const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
    // return axios.get(urlAPI + versionAPI + '/claim'+qString,{
    // return axios.get(urlAPI + versionAPI + '/inspection'+qString,{
    //     headers: {
    //         Authorization: headers
    //     }
    // })
    return axios.post(urlAPI + versionAPI + '/' + tab + '/saveCaseStep',data)
        .then(res => {
            return res
        })
    .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          // console.log(error.response.data);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          var result = [];
          result["data"] = error.response.data;
          result["status"] = error.response.status;
          return result
        } else if (error.request) {
          // The request was made but no response was received
          // console.log(error.request);
          return "The request was made but no response was received"
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
          return "Something happened in setting up the request that triggered an Error"
        }
    });
}










// export function Login(data) {
//     return axios.post(urlAPI + versionAPI + '/login',data)
//         .then(response => {
//             return response
//         }).catch(err => {
//             return err.response
//         })
// }
// export function GetUserMe(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     // console.log(headers);
//     return axios.get(urlAPI + versionAPI + '/user/me',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function GetListCase(qString){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     // return axios.get(urlAPI + versionAPI + '/claim'+qString,{
//     return axios.get(urlAPI + versionAPI + '/inspection'+qString,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function GetCaseID(caseID){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/claim/'+caseID,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function GetRemark(caseID, data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/claim/'+caseID+'/remark',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function AddRemark(caseID, data){
//     console.log("data",data);
//     console.log("caseID",caseID);
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/claim/'+caseID+'/addremark',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function GetListSurveyor(qString){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/surveyor'+qString,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//         })
// }
// export function AddNewClaim(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/claim',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function EditClaim(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/claim/'+data.caseID+'/update',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function SendSMSAppointment(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/claim/sendSMS',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function AssignSurvey(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/claim/'+data.caseID+'/assign',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function ChangePasswordMe(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/user/me/changepassword',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//     })
// }
// export function ChangePassword(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/user/'+data.userID+'/changepassword',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//     })
// }


// // ****** Dashboard ****** //
// export function GetDashboard(){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/claim/dashboard',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// // ****** Supervisor ****** //
// export function GetSupervisorListCase(qString){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/supervisor'+qString,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function GetSupervisorCaseDetail(caseID){    // maybe not use (total-tab.js)
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/supervisor/'+caseID,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function GetSupervisorCaseImages(id){    // maybe not use (total-tab.js)
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/getimage/'+id,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function EditCaseSummary(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/supervisor/'+data.caseID+'/update/summary',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function SFTPUpload(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + '/sftp/uploadfile',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function InspectionStatus(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + '/CarInspection/status',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function EditCaseAccident(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/supervisor/'+data.caseID+'/update/accident',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function AddCarTP(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/supervisor/'+data.caseID+'/add/TP',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function EditCarTP(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/supervisor/'+data.caseID+'/update/TP',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function DeleteCarTP(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/supervisor/'+data.caseID+'/delete/TP',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function AddInjury(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/supervisor/'+data.caseID+'/add/INJ',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function EditInjury(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/supervisor/'+data.caseID+'/update/INJ',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function DeleteInjury(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/supervisor/'+data.caseID+'/delete/INJ',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function AddAsset(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/supervisor/'+data.caseID+'/add/asset',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function EditAsset(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/supervisor/'+data.caseID+'/update/asset',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function DeleteAsset(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/supervisor/'+data.caseID+'/delete/asset',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//     .then(res => {
//         return res
//     })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// export function addImageToGCS(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/uploadimage',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// export function deleteImageFromGCS(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/deleteimage',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// export function sendPDFToGCS(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/sendPDFToGCS',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// // ****** Administration ****** //
// export function getListUser(qString = ''){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/admin/listuser'+qString,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function EditUser(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     // return axios.post(urlAPI + versionAPI + '/user/'+data.userID+'/update',data,{
//     return axios.post(urlAPI + versionAPI + '/admin/user/'+data.userID+'/updateUser',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//           console.log(res)
//             return res
//         })
//         // .catch(err => {
//         //   console.log(err.res)
//         //     return err.res
//         // })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function AddUser(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/admin/register',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//         // .catch(err => {
//         //     return err.res
//         // })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function adminChangePassword(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/admin/user/'+data.userID+'/changepassword',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// export function SetActiveUser(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/admin/user/'+data.userID+'/active',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// export function DeleteCaseID(caseID){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.delete(urlAPI + versionAPI + '/claim/'+caseID,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         }).catch(err => {
//             return err.res
//     })
// }

// export function GetAdminListCase(qString){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/admin/listcase'+qString,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// export function UpdateStatusCaseByAdmin(data, caseID){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     // console.log("data",data);
//     // console.log("caseID",caseID);
//     return axios.post(urlAPI + versionAPI + '/admin/case/'+caseID+'/updateStatus',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }


// // ****** Admin ****** //
// export function getProfileImage(userID){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPIMobile + '/getprofile/'+userID,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// export function editProfileImage(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     // return axios.post(urlAPI + versionAPI + '/login',data)
//     return axios.post(urlAPI + versionAPIMobile + '/uploadprofile',data,{
//         headers: {
//             Authorization: headers,
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// export function putProfileImage(data){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     console.log(data);
//     // return axios.post(urlAPI + versionAPI + '/login',data)
//     return axios.put(urlAPI + versionAPIMobile + '/uploadprofile',data,{
//         headers: {
//             Authorization: headers,
//             // 'Access-Control-Allow-Origin': '*',
//             // 'Access-Control-Allow-Headers': '*',
//             // 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }


// // ****** War Room ****** //
// export function getListSurveyor_WR(qString = ''){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/surveyor/wr'+qString,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//         .catch(function (error) {
//             if (error.response) {
//               var result = [];
//               result["data"] = error.response.data;
//               result["status"] = error.response.status;
//               return result
//             } else if (error.request) {
//               return "The request was made but no response was received"
//             } else {
//               return "Something happened in setting up the request that triggered an Error"
//             }
//         });
// }
// export function getSurveyorDetail_WR(surveyorID){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/surveyor/wr/'+surveyorID,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//         .catch(function (error) {
//             if (error.response) {
//               var result = [];
//               result["data"] = error.response.data;
//               result["status"] = error.response.status;
//               return result
//             } else if (error.request) {
//               return "The request was made but no response was received"
//             } else {
//               return "Something happened in setting up the request that triggered an Error"
//             }
//         });
// }
// export function saveCallFlag(data, surveyorID, call_type, caseID) {
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI + '/surveyor/wr/'+surveyorID+'/'+call_type+'/'+caseID,data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//         .catch(function (error) {
//             if (error.response) {
//               var result = [];
//               result["data"] = error.response.data;
//               result["status"] = error.response.status;
//               return result
//             } else if (error.request) {
//               return "The request was made but no response was received"
//             } else {
//               return "Something happened in setting up the request that triggered an Error"
//             }
//         });
// }

// // ****** report ****** //
// export function getListOperation(qString = ''){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/operation'+qString,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// // ****** report ****** //
// export function getListBilling(qString = ''){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/billing'+qString,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// export function getDamagePart(caseID){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/damagepart/'+caseID,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// export function GetExtra(id){   // Ref By Amphur
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI +'/extra/'+id+ '/get',{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// export function UpdateExtra(data, id){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.post(urlAPI + versionAPI +'/extra/'+id+ '/update',data,{
//         headers: {
//             Authorization: headers
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }

// export function exportExcel(type, qString){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + versionAPI + '/' + type + '/exportExcel'+qString,{
//         headers: {
//             Authorization: headers,
//             'Content-Type': 'blob',
//             responseType:'arraybuffer'
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }


// ////////////////// API web.php //////////////////
// export function screenShotPDF(qString){
//     const headers = JSON.parse(sessionStorage.getItem('auth')).auth;
//     return axios.get(urlAPI + '/pdf'+qString,{
//         headers: {
//             Authorization: headers,
//             // 'Content-Type': 'blob',
//             responseType:'blob',
//             'Content-Type': 'application/json',
//             // responseType:'arraybuffer',
//         }
//     })
//         .then(res => {
//             return res
//         })
//     .catch(function (error) {
//         if (error.response) {
//           // Request made and server responded
//           // console.log(error.response.data);
//           // console.log(error.response.status);
//           // console.log(error.response.headers);
//           var result = [];
//           result["data"] = error.response.data;
//           result["status"] = error.response.status;
//           return result
//         } else if (error.request) {
//           // The request was made but no response was received
//           // console.log(error.request);
//           return "The request was made but no response was received"
//         } else {
//           // Something happened in setting up the request that triggered an Error
//           // console.log('Error', error.message);
//           return "Something happened in setting up the request that triggered an Error"
//         }
//     });
// }
// //////////////////////////////////////////////////////

